import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { fetchTenantBuilding as fetchTenantBuildingAction } from './actions';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { getErrorCode } from 'store/utils';

export const fetchTenantBuilding: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(fetchTenantBuildingAction.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      return apiClient(state)
        .fetchTenantBuilding(payload)
        .pipe(
          map(({ response }) => fetchTenantBuildingAction.success(response)),
          catchError((error: Error) =>
            of(fetchTenantBuildingAction.failure({ error, errorCode: getErrorCode(error) })),
          ),
        );
    }),
  );
